import { Injectable, inject } from '@angular/core';
import { LoginStatus } from './login-status-service';
import { Router } from '@angular/router';

const SECONDS_UNTIL_AUTO_LOGOUT = 6000; // in seconds
const CHECK_INTERVAL = 10000; // in ms
const STORE_KEY = 'lastAction';

// This is adapted from
// https://stackoverflow.com/questions/45911893/automatic-logout-in-angular-2-after-few-minutes

@Injectable({ providedIn: 'root' })
export class AutoLogoutService {

  loggedIn = false;

  private _Router = inject(Router);
  private _LoginStatus = inject(LoginStatus);

  constructor() {
    this._LoginStatus.loggedIn.subscribe((val) => {
      this.loggedIn = val;
    });
  }

  public getLastAction() {
    return parseInt(sessionStorage.getItem(STORE_KEY), 10);
  }
  public setLastAction(lastAction: number) {
    sessionStorage.setItem(STORE_KEY, lastAction.toString());
  }



  init() {
    // this.check();
    this.initListener();
    this.initInterval();
    sessionStorage.setItem(STORE_KEY, Date.now().toString());
  }

  initListener() {



    document.body.addEventListener('click', () => this.reset());
    document.body.addEventListener('mouseover', () => this.reset());
    document.body.addEventListener('mouseout', () => this.reset());
    document.body.addEventListener('keydown', () => this.reset());
    document.body.addEventListener('keyup', () => this.reset());
    document.body.addEventListener('keypress', () => this.reset());
  }

  destroy() {
    document.body.removeEventListener('click', () => this.reset());
    document.body.removeEventListener('mouseover', () => this.reset());
    document.body.removeEventListener('mouseout', () => this.reset());
    document.body.removeEventListener('keydown', () => this.reset());
    document.body.removeEventListener('keyup', () => this.reset());
    document.body.removeEventListener('keypress', () => this.reset());
    this.reset();
  }

  reset() {
    this.setLastAction(Date.now());
  }

  initInterval() {
    setInterval(() => {
      this.check();
    }, CHECK_INTERVAL);
  }

  check() {

    if (this.loggedIn) {

      const now = Date.now();
      const timeleft = this.getLastAction() + SECONDS_UNTIL_AUTO_LOGOUT * 1000;
      const diff = timeleft - now;
      const isTimeout = diff < 0;

      if (isTimeout) {
        sessionStorage.removeItem(STORE_KEY);
        this._LoginStatus.logout();
        this.destroy();
        this._Router.navigate(['/welcome'], { queryParams: { isAutoLogout: 'true' } });
      }
    }
  }
}


